<template>
  <div
    v-if="live"
    class="apertura-inside container-fluid mb-6"
    data-epica-module-name="Apertura En Vivo"
  >
    <div
      class="container"
      v-if="live.feedTitle && live.feed && live.feed.length"
    >
      <div class="row en-vivo">
        <div class="col d-flex align-items-center mb-3">
          <div class="icon-live">
            <img
              class=""
              src="https://s.lalr.co/lr/images/icon-live-gif.gif"
              alt="Icono Live"
            /><span>EN VIVO</span>
          </div>
          <div>
            <img
              v-if="live.isInside"
              alt="Logo Inside"
              class="logoInsideHome"
              src="https://s.lalr.co/lr/images/logos/logo-inside.png"
            />
          </div>
        </div>
      </div>
      <div class="d-flex">
        <div class="flex-grow-1">
          <div class="V_Video_Title">
            <div
              class="embed-responsive embed-responsive-16by9"
              v-html="live.embedVideo"
            ></div>

            <text-fill v-cloak group-name="ih" :max-font-size="25">
              <a class="insideSect" v-html="live.title"></a>
            </text-fill>
          </div>
        </div>
        <div class="feedInside d-flex flex-column">
          <h2 class="title-feed-inside" v-html="live.feedTitle"></h2>
          <div class="wrap-feed d-flex flex-column flex-grow-1">
            <div class="feed-inside flex-grow-1">
              <div
                class="list-feed"
                v-for="(item, index) in live.feed"
                :key="index"
              >
                <img
                  v-if="item.image"
                  :src="item.image.url"
                  :alt="item.image.alt"
                />
                <span class="hour" v-html="item.time"></span>
                <span class="date" v-html="item.date"></span>
                <div v-html="item.content"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container without-feed" v-else>
      <div class="row">
        <div class="col-8">
          <img
            alt="Logo Inside"
            v-if="live.isInside"
            class="logoInsideHome"
            src="http://s.lalr.co/lr/images/logos/logo-inside.png"
          />
          <div
            class="embed-responsive embed-responsive-16by9"
            v-html="live.embedVideo"
          ></div>
        </div>
        <div class="col-4">
          <div class="d-flex flex-column title-inside">
            <span class="kicker">EN VIVO</span>
            <text-fill
              v-cloak
              group-name="ih"
              class="flex-grow-1"
              :max-font-size="25"
            >
              <a class="insideSect" v-html="live.title"></a>
            </text-fill>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { TextFill } from "./../text-fill/TextFill.vue";
export default {
  components: { TextFill },
  props: {
    loadLive: Boolean,
  },
  created: function () {
    this.init();
    if (this.loadLive) {
      this.getLive();
    }
  },
  updated: function () {
    if (this.live) {
      document.dispatchEvent(window.lrLoad);
    }
  },
  computed: {
    ...mapGetters("live", {
      live: "data",
    }),
  },
  methods: {
    ...mapActions("live", {
      init: "init",
      getLive: "getLive",
    }),
  },
};
</script>